import spotifyIcon from '../assets/spotify_icon.png'
import logo from '../eye-mask.svg'
export const SpotifyAuthSuccess = () => {

    return (
        <div className='flex-column center-both' style={{ height: '100%' }} >
            <img src={spotifyIcon} alt="" style={{ width: '60%' }} />
            <img src={logo} alt="" style={{ width: '60%' }} />
            <div style={{height: 20}} ></div>
            <span className="material-icons-outlined" style={{color:'green', fontSize:50}} >
                check_circle
            </span>
            <h3>Authorization Successful</h3>
            <h4>Please enjoy jamming together :D</h4>
        </div>
    )
}